/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import {Checkbox, message} from 'antd'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import FromToPicker from '../BaseComponent/FromToPicker'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Pageing from '../Pagination/pageing'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
// import {GoogleApiWrapper, InfoWindow, Map, Marker, Polyline} from "google-maps-react";
import {Map, Marker, TileLayer, Popup, Polyline} from 'react-leaflet'
import Loader from '../loaders/loader'

import RETAIL from '../BaseComponent/RETAIL'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {guide, speedGuide} from '../mapComponents/guide'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import ReportDelivered from './components/reportDelivered'
import ReportLocation from './components/reportLocations'
import moment from 'moment-jalali'
class ReportDriverCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: 25,
      width: 20,
      drivers: [],
      driverId: '',
      activeTab: 0,
      sizeNotEditedNotLocation: 10,
      numberNotEditedNotLocation: 1,
      listNotEditedNotLocation: [],
      sizeNotDelivered: 10,
      numberNotDelivered: 1,
      listNotDelivered: [],
      sizeEditedAddress: 10,
      numberEditedAddress: 1,
      listEditedAddress: [],
      history: [],
      arrayOfPoint: [],
      final: [],
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      showSearch: 'location',
      showFinalSearch: 'location',
      currentPosition: [],
      deliveredItems: [],
      countDeliveredItems: 0,
      deliveredLocations: [],
      countDeliveredLocations: 0,
      pos: [],
      notLocationFiltered: false,
      notDeliveredFiltered: false,
      editedAddressFiltered: false,
      trajectoryFiltered: false,
      currentLocationFiltered: false,
      deliveredFiltered: false,
      locationFiltered: false,
      currentTab: 'notLocation',
      filtered: false,
      progressing: false
    }
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
        }
      })
      .catch((error) => {})

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.numberNotEditedNotLocation !== this.state.numberNotEditedNotLocation) {
      this.toggleLoading(true)

      this.getReportNotEditedNotLocation(this.state.driverId).then(() => {
        this.toggleLoading(false)
      })
    }
    if (prevState.numberNotDelivered !== this.state.numberNotDelivered) {
      this.toggleLoading(true)

      this.getReportNotDelivered(this.state.driverId).then(() => {
        this.toggleLoading(false)
      })
    }
    if (prevState.numberEditedAddress !== this.state.numberEditedAddress) {
      this.toggleLoading(true)
      this.getEditedAddress(this.state.driverId).then(() => {
        this.toggleLoading(false)
      })
    }
  }

  getValueDriver = (driverId) => {
    if (driverId === null) {
      this.setState({
        driverId: ''
      })
    } else {
      this.setState({
        driverId: driverId.personId
      })
    }
  }

  changeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  changeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getReportNotEditedNotLocation = (driverId) => {
    let filter = {
      pageSize: this.state.sizeNotEditedNotLocation,
      pageNumber: this.state.numberNotEditedNotLocation,
      planDateMin: this.state.fromDate,
      planDateMax: this.state.toDate,
      driverId,
      export: false,
      sortBy: 'dispatchDate_asc'
    }
    return http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_NOTEDITED}`, {
        params: filter
      })
      .then((res) => {
        this.setState({
          notLocationFiltered: true
        })
        if (res.data.error === null) {
          this.setState({
            listNotEditedNotLocation: res.data.object.result,
            countAllNotEditedNotLocation: res.data.object.countAll
          })
        }
      })
  }

  getReportNotDelivered = (driverId) => {
    let filter = {
      pageSize: this.state.sizeNotDelivered,
      pageNumber: this.state.numberNotDelivered,
      planDateMin: this.state.fromDate,
      planDateMax: this.state.toDate,
      driverId,
      export: false,
      sortBy: 'dispatchDate_asc'
    }
    return http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COORDINATE_INCOMPATIBLE}`, {
        params: filter
      })
      .then((res) => {
        this.setState({
          notDeliveredFiltered: true
        })
        if (res.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            listNotDelivered: res.data.object.result,
            countAllNotDelivered: res.data.object.countAll
          })
        }
      })
  }

  openMapNotEditedNotLocation = (latitude, longitude, recipientName) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      mapModalNotEditedNotLocation: true
    })
  }

  getPageNumberNotEditedNotLocation = (numberNotEditedNotLocation) => {
    this.setState({
      numberNotEditedNotLocation
    })
  }

  getPageNumberNotDelivered = (numberNotDelivered) => {
    this.setState({
      numberNotDelivered
    })
  }

  openMapNotDelivered = (latitude, longitude, recipientName, customerLatitude, customerLongitude, address) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      customerLatitude,
      customerLongitude,
      address,
      mapModalNotDelivered: true
    })
  }

  getEditedAddress = (editorId) => {
    let filter = {
      pageSize: this.state.sizeEditedAddress,
      pageNumber: this.state.numberEditedAddress,
      editionTimeMin: this.state.fromDate,
      editionTimeMax: this.state.toDate,
      editorId,
      export: false,
      sortBy: 'editionTime_desc'
    }
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_EDITEDADDRESS}`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          editedAddressFiltered: true
        })
        if (response.data.error == null) {
          this.setState({
            listEditedAddress: response.data.object.result,
            countAllEditedAddress: response.data.object.countAll
          })
        }
      })
  }

  getPageNumberEditedAddress = (numberEditedAddress) => {
    this.setState({
      numberEditedAddress
    })
  }

  showLocationEditedAddress = (latitude, longitude, recipientName, id, confirmed) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      id,
      modalEditedAddress: !this.state.modalEditedAddress,
      confirmedAddress: confirmed
    })
  }

  confirm = (id, recipientName) => {
    this.setState({
      id,
      recipientName,
      confirmModal: !this.state.confirmModal,
      modalEditedAddress: false
    })
  }

  confirmOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    this.setState({
      progressing: true
    })
    http
      .post(`${RETAIL.RETAIL_COMPANY_EDITEDADDRESSES_CONFIRM}`, data, {})
      .then((response) => {
        this.setState({
          progressing: false
        })
        if (response.data.error === null) {
          message.success('آدرس با موفقیت ثبت شد')
          let driverId = this.state.driverId
          this.setState({
            confirmModal: false
          })
          this.getEditedAddress(driverId)
        } else {
          message.error(response.data.description)
        }
      })
      .catch(() => {
        this.setState({
          progressing: false
        })
      })
  }

  changeFieldConfirm(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  changeColorMarker = (state, hour) => {
    var icon
    if (state === 100) {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = require('../../pin-black/24-06.png')
          break
        case '06':
          icon = require('../../pin-black/06-07.png')
          break
        case '07':
          icon = require('../../pin-black/07-08.png')
          break
        case '08':
          icon = require('../../pin-black/08-09.png')
          break
        case '09':
          icon = require('../../pin-black/09-10.png')
          break
        case '10':
          icon = require('../../pin-black/10-11.png')
          break
        case '11':
          icon = require('../../pin-black/11-12.png')
          break
        case '12':
          icon = require('../../pin-black/12-13.png')
          break
        case '13':
          icon = require('../../pin-black/13-14.png')
          break
        case '14':
          icon = require('../../pin-black/14-15.png')
          break
        case '15':
          icon = require('../../pin-black/15-16.png')
          break
        case '16':
          icon = require('../../pin-black/16-17.png')
          break
        case '17':
          icon = require('../../pin-black/17-18.png')
          break
        case '18':
          icon = require('../../pin-black/18-19.png')
          break
        case '19':
          icon = require('../../pin-black/19-20.png')
          break
        case '20':
          icon = require('../../pin-black/20-21.png')
          break
        case '21':
          icon = require('../../pin-black/21-22.png')
          break
        case '22':
          icon = require('../../pin-black/22-23.png')
          break
        case '23':
          icon = require('../../pin-black/23-24.png')
          break
        default:
          icon = require('../../image/miniLoc.png')
      }
      return icon
    } else {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = require('../../pin-white/24-06.png')
          break
        case '06':
          icon = require('../../pin-white/06-07.png')
          break
        case '07':
          icon = require('../../pin-white/07-08.png')
          break
        case '08':
          icon = require('../../pin-white/08-09.png')
          break
        case '09':
          icon = require('../../pin-white/09-10.png')
          break
        case '10':
          icon = require('../../pin-white/10-11.png')
          break
        case '11':
          icon = require('../../pin-white/11-12.png')
          break
        case '12':
          icon = require('../../pin-white/12-13.png')
          break
        case '13':
          icon = require('../../pin-white/13-14.png')
          break
        case '14':
          icon = require('../../pin-white/14-15.png')
          break
        case '15':
          icon = require('../../pin-white/15-16.png')
          break
        case '16':
          icon = require('../../pin-white/16-17.png')
          break
        case '17':
          icon = require('../../pin-white/17-18.png')
          break
        case '18':
          icon = require('../../pin-white/18-19.png')
          break
        case '19':
          icon = require('../../pin-white/19-20.png')
          break
        case '20':
          icon = require('../../pin-white/20-21.png')
          break
        case '21':
          icon = require('../../pin-white/21-22.png')
          break
        case '22':
          icon = require('../../pin-white/22-23.png')
          break
        case '23':
          icon = require('../../pin-white/23-24.png')
          break
        default:
          icon = require('../../image/miniLoc.png')
      }
      return icon
    }
  }

  changeColorMarkerBySpeed = (state, speed) => {
    var icon
    if (state === 100) {
      if (speed >= 0 && speed <= 60) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/15-16.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/15-16.png')
        return icon
      } else if (speed > 60 && speed <= 90) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/17-18.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/17-18.png')
        return icon
      } else if (speed > 90 && speed <= 110) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/20-21.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/20-21.png')
        return icon
      } else {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/24-06.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/24-06.png')
        return icon
      }
    } else {
      if (speed >= 0 && speed <= 60) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/15-16.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/15-16.png')
        return icon
      } else if (speed > 60 && speed <= 90) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/17-18.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/17-18.png')
        return icon
      } else if (speed > 90 && speed <= 110) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/20-21.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/20-21.png')
        return icon
      } else {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/24-06.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/24-06.png')
        return icon
      }
    }
  }

  getTrajectory = (driverId) => {
    let data = {
      from: this.state.fromDate,
      to: this.state.toDate,
      driverID: driverId
    }
    return http
      .post(`${RETAIL.RETAIL_MANAGE_TRAJECTORY_DRIVER_RANGE}`, data, {})
      .then((response) => {
        this.setState({
          trajectoryFiltered: true
        })
        if (response.data.error === null) {
          this.setState({
            final: [],
            arrayOfPoint: [],
            showFinalSearch: this.state.showSearch
          })
          let array = response.data.object
          let emptyArray = []
          this.setState({
            history: response.data.object
          })
          for (let i = 0; i < array.length; i++) {
            this.setState({
              arrayOfPoint: this.state.arrayOfPoint.concat(array[i].locations),
              final: this.state.arrayOfPoint.concat(array[i].locations)
            })
            // alert(JSON.stringify(this.state.final))
          }
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onMarkerClick(props, marker, e) {
    console.log(marker)
    console.log(props)
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  showSearchBy = (e) => {
    let name = e.target.name
    this.setState({
      [name]: e.target.value
    })
  }

  getCurrentTrajectory = (driverId) => {
    let data = {
      driverId
    }
    return http
      .post(`${RETAIL.RETAIL_MANAGE_TRAJECTORY_DRIVER_CURRENT}`, data, {})
      .then((response) => {
        this.setState({
          currentLocationFiltered: true
        })
        if (response.data.error == null) {
          this.setState({
            currentPosition: response.data.object.locations
          })
        } else {
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  live = (driverId) => {
    let filter = {
      driverId
    }
    http
      .get(`${RETAIL.RETAIL_MANAGE_LOCATION_DRIVER_LIST}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          // alert(JSON.stringify(res))
        }
      })
  }

  filter() {
    let {toDate, fromDate} = this.state
    let driverId = this.state.driverId
    if (driverId === '' || toDate === '' || fromDate === '') {
      message.error('همه ی فیلد ها وارد شود')
    } else if ((toDate !== '' || toDate === null) && isNaN(toDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if ((fromDate !== '' || fromDate == null) && isNaN(fromDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else {
      this.setState(
        {
          loading: true,
          notLocationFiltered: false,
          notDeliveredFiltered: false,
          editedAddressFiltered: false,
          trajectoryFiltered: false,
          currentLocationFiltered: false,
          deliveredFiltered: false,
          locationFiltered: false
        },
        () => {
          if (this.state.currentTab === 'notLocation') {
            this.getReportNotEditedNotLocation(driverId).then(() => {
              this.toggleLoading(false)
            })
          } else if (this.state.currentTab === 'notDelivered') {
            this.getReportNotDelivered(driverId).then(() => {
              this.toggleLoading(false)
            })
          } else if (this.state.currentTab === 'editedAddress') {
            this.getEditedAddress(driverId).then(() => {
              this.toggleLoading(false)
            })
          } else if (this.state.currentTab === 'trajectory') {
            this.getTrajectory(driverId).then(() => {
              this.toggleLoading(false)
            })
          } else if (this.state.currentTab === 'currentLocation') {
            this.getCurrentTrajectory(driverId).then(() => {
              this.toggleLoading(false)
            })
          } else if (this.state.currentTab === 'delivered') {
            this.getDelivered({
              driverId,
              planDateMin: fromDate,
              planDateMax: toDate,
              pageNumber: 1,
              pageSize: 50,
              sortBy: '',
              export: false
            }).then(() => {
              this.toggleLoading(false)
            })
          } else if (this.state.currentTab === 'locations') {
            var a = moment(fromDate)
            var b = moment(toDate)
            if (b.diff(a, 'days') > 30) {
              this.setState({
                loading: false
              })
              message.error('اختلاف تاریخ باید حداکثر تا ۳۰ روز باشد')
            } else {
              this.deliveredLocation({
                driverId,
                planDateMin: fromDate,
                planDateMax: toDate,
                export: true,
                pageNumber: 1
              }).then(() => {
                this.toggleLoading(false)
              })
            }
          }
        }
      )
    }
  }

  getDelivered = (params) => {
    return http
      .get(`report/dispatch/deliveryPack/delivered/master`, {
        params
      })
      .then((res) => {
        this.setState({
          deliveredFiltered: true
        })
        if (!res.data.error) {
          this.setState({
            deliveredItems: res.data.object.result,
            countDeliveredItems: res.data.object.countAll,
            deliveredReportPageNumber: 1
          })
        }
      })
      .catch(() => {})
  }

  deliveredLocation = (params) => {
    return http
      .get(`report/dispatch/deliveryPack/delivery/location`, {
        params
      })
      .then((res) => {
        this.setState({
          locationFiltered: true
        })
        if (!res.data.error) {
          this.setState({
            deliveredLocations: res.data.object.result,
            countDeliveredLocations: res.data.object.countAll
          })
        } else {
          message.error(res.data.description)
          this.setState({
            deliveredLocations: [],
            countDeliveredLocations: 0
          })
        }
      })
      .catch(() => {})
  }

  refreshGetLocations = (params) => {
    this.setState({
      loading: true
    })
    return http
      .get(`report/dispatch/deliveryPack/delivery/location`, {
        params
      })
      .then((res) => {
        this.setState({
          loading: false
        })
        if (!res.data.error) {
          this.setState({
            deliveredLocations: res.data.object.result,
            countDeliveredLocations: res.data.object.countAll
          })
        } else {
          this.setState({
            deliveredLocations: [],
            countDeliveredLocations: 0
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  refreshGetDelivered = (params) => {
    this.setState({
      loading: true
    })
    return http
      .get(`report/dispatch/deliveryPack/delivered/master`, {
        params
      })
      .then((res) => {
        this.setState({
          loading: false
        })
        if (!res.data.error) {
          this.setState({
            deliveredItems: res.data.object.result,
            countDeliveredItems: res.data.object.countAll,
            deliveredReportPageNumber: params.pageNumber
          })
        }
      })
  }

  changeColorMarker = (state, hour) => {
    var icon
    if (state === 100) {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/24-06.png')} height={this.state.height} width={this.state.width} />
          )
          break
        case '06':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/06-07.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/06-07.png");
          break
        case '07':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/07-08.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/07-08.png");
          break
        case '08':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/08-09.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/08-09.png");
          break
        case '09':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/09-10.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/09-10.png");
          break
        case '10':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/10-11.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/10-11.png");
          break
        case '11':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/11-12.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/11-12.png");
          break
        case '12':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/12-13.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/12-13.png");
          break
        case '13':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/13-14.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/13-14.png");
          break
        case '14':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/14-15.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/14-15.png");
          break
        case '15':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/15-16.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/15-16.png");
          break
        case '16':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/16-17.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/16-17.png");
          break
        case '17':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/17-18.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/17-18.png");
          break
        case '18':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/18-19.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/18-19.png");
          break
        case '19':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/19-20.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/19-20.png");
          break
        case '20':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/20-21.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/20-21.png");
          break
        case '21':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/21-22.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/21-22.png");
          break
        case '22':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/22-23.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/22-23.png");
          break
        case '23':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/23-24.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/23-24.png");
          break
        default:
          icon = renderToStaticMarkup(
            <img src={require('../../image/miniLoc.png')} height={this.state.height} width={this.state.width} />
          )
        //   icon = require("../../image/miniLoc.png");
      }
      return icon
    } else {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/24-06.png')} height={this.state.height} width={this.state.width} />
          )
          break
        case '06':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/06-07.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/06-07.png");
          break
        case '07':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/07-08.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/07-08.png");
          break
        case '08':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/08-09.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/08-09.png");
          break
        case '09':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/09-10.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/09-10.png");
          break
        case '10':
          icon = renderToStaticMarkup(
            <img
              src={require('../../pin-white/10-11.png')}
              height={this.state.height}
              width={this.state.width}
              style={{marginBottom: '10px'}}
            />
          )
          //   icon = require("../../pin-white/10-11.png");
          break
        case '11':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/11-12.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/11-12.png");
          break
        case '12':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/12-13.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/12-13.png");
          break
        case '13':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/13-14.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/13-14.png");
          break
        case '14':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/14-15.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/14-15.png");
          break
        case '15':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/15-16.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/15-16.png");
          break
        case '16':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/16-17.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/16-17.png");
          break
        case '17':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/17-18.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/17-18.png");
          break
        case '18':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/18-19.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/18-19.png");
          break
        case '19':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/19-20.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/19-20.png");
          break
        case '20':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/20-21.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/20-21.png");
          break
        case '21':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/21-22.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/21-22.png");
          break
        case '22':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/22-23.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/22-23.png");
          break
        case '23':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/23-24.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/23-24.png");
          break
        default:
          icon = renderToStaticMarkup(
            <img src={require('../../image/miniLoc.png')} height={this.state.height} width={this.state.width} />
          )
        //   icon = require("../../image/miniLoc.png");
      }
      return icon
    }
  }

  getMarkers() {
    let points = this.state.currentPosition
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lon) {
        array.push({
          location: [item.lat, item.lon],
          ...item
        })
      }
    })
    return array
  }

  getMarkersHistory() {
    let points = this.state.arrayOfPoint
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lon) {
        array.push({
          location: [item.lat, item.lon],
          ...item
        })
      }
    })
    return array
  }

  toggleLoading = (val) => {
    this.setState({
      loading: val,
      filtered: true
    })
  }

  changeTab = (index, item) => {
    let {toDate, fromDate} = this.state
    let driverId = this.state.driverId
    if (!toDate || !fromDate || !driverId) {
      message.error('همه فیلتر ها وارد شود')
    } else if ((toDate !== '' || toDate === null) && isNaN(toDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if ((fromDate !== '' || fromDate == null) && isNaN(fromDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else {
      this.setState({activeTab: index, currentTab: item.value}, () => {
        if (item.value === 'notLocation' && !this.state.notLocationFiltered) {
          this.toggleLoading(true)
          this.getReportNotEditedNotLocation(driverId)
            .then(() => {
              this.toggleLoading(false)
            })
            .catch(() => {
              this.toggleLoading(false)
            })
        } else if (item.value === 'notDelivered' && !this.state.notDeliveredFiltered) {
          this.toggleLoading(true)
          this.getReportNotDelivered(driverId)
            .then(() => {
              this.toggleLoading(false)
            })
            .catch(() => {
              this.toggleLoading(false)
            })
        } else if (item.value === 'editedAddress' && !this.state.editedAddressFiltered) {
          this.toggleLoading(true)
          this.getEditedAddress(driverId)
            .then(() => {
              this.toggleLoading(false)
            })
            .catch(() => {
              this.toggleLoading(false)
            })
        } else if (item.value === 'trajectory' && !this.state.trajectoryFiltered) {
          this.toggleLoading(true)
          this.getTrajectory(driverId)
            .then(() => {
              this.toggleLoading(false)
            })
            .catch(() => {
              this.toggleLoading(false)
            })
        } else if (item.value === 'currentLocation' && !this.state.currentLocationFiltered) {
          this.toggleLoading(true)
          this.getCurrentTrajectory(driverId)
            .then(() => {
              this.toggleLoading(false)
            })
            .catch(() => {
              this.toggleLoading(false)
            })
        } else if (item.value === 'delivered' && !this.state.deliveredFiltered) {
          this.toggleLoading(true)
          this.getDelivered({
            driverId,
            planDateMin: fromDate,
            planDateMax: toDate,
            pageNumber: 1,
            pageSize: 50,
            sortBy: '',
            export: false
          }).then(() => {
            this.toggleLoading(false)
          })
        } else if (item.value === 'locations' && !this.state.locationFiltered) {
          var a = moment(fromDate)
          var b = moment(toDate)
          if (b.diff(a, 'days') > 30) {
            this.setState({
              loading: false
            })
            message.error('اختلاف تاریخ باید حداکثر تا ۳۰ روز باشد')
          } else {
            this.toggleLoading(true)
            this.deliveredLocation({
              driverId,
              planDateMin: fromDate,
              planDateMax: toDate,
              export: true,
              pageNumber: 1
            }).then(() => {
              this.toggleLoading(false)
            })
          }
        }
      })
    }
  }

  render() {
    var {final} = this.state
    for (let i = 0; i < final.length; i++) {
      final[i]['lat'] = final[i]['lat']
      final[i]['lng'] = final[i]['lon']
    }

    var {currentPosition} = this.state
    for (let i = 0; i < currentPosition.length; i++) {
      currentPosition[i]['lat'] = currentPosition[i]['lat']
      currentPosition[i]['lng'] = currentPosition[i]['lon']
    }
    let {history, listEditedAddress, listNotDelivered, listNotEditedNotLocation} = this.state

    const modalStyle = {
      maxWidth: '96%',
      height: '300px'
    }
    const style = {
      width: '100%',
      height: '400px',
      margin: 'auto',
      position: 'relative !important'
    }

    const limeOptions = {color: '#000'}

    const orangeIcon = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    const greenIcon = renderToStaticMarkup(<img src={require('../../image/finishPack.png')} />)

    const car = renderToStaticMarkup(<img src={require('../../image/car_in_service.png')} />)

    let stepData = [
      {
        title: <div>فاکتور های بدون موقعیت و ویرایش نشده</div>,
        content: (
          <>
            {this.state.listNotEditedNotLocation.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>راننده</td>
                      <td>تاریخ تحویل</td>
                      <td>تحویل </td>
                      <td>شناسه فاکتور</td>
                      <td>شماره فاکتور</td>
                      <td>تاریخ ثبت</td>
                      <td>نام خریدار</td>
                      <td>نام تحویل گیرنده</td>
                      <td>موبایل</td>
                      <td>موقعیت</td>
                    </tr>
                    {this.state.listNotEditedNotLocation.map((list, index) => (
                      <tr key={index}>
                        <td>
                          {(this.state.numberNotEditedNotLocation - 1) * this.state.sizeNotEditedNotLocation +
                            index +
                            1}
                        </td>
                        <td>
                          <span title={list.driver !== null ? list.driver.mobile : ''}>
                            {list.driver === null ? '-' : list.driver.name}
                          </span>
                        </td>
                        <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                        <td>{list.deliveredBetween ? 'در بازه' : 'خارج از بازه'}</td>
                        <td>
                          <Link
                            to={{
                              pathname: '/baskets',
                              search: `?invoiceId=${list.invoice.invoiceId}`
                            }}
                            target={'_blank'}
                          >
                            {list.invoice.invoiceId}
                          </Link>
                        </td>
                        <td>{list.invoice.invoiceNum}</td>
                        <td>{jMoment(list.invoice.registerDate).format('jYY/jM/jD HH:mm')}</td>
                        <td>{list.invoice.buyerName}</td>
                        <td>{list.invoice.recipientName}</td>
                        <td>{list.invoice.mobile === null ? '-' : list.invoice.mobile.replace(/\+98/g, '0')}</td>
                        <td>
                          <button
                            onClick={() =>
                              this.openMapNotEditedNotLocation(
                                list.latitude,
                                list.longitude,
                                list.invoice.recipientName
                              )
                            }
                          >
                            <img src={require('../../image/loc.svg')} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberNotEditedNotLocation}
                    pageSize={this.state.sizeNotEditedNotLocation}
                    currentPage={this.state.numberNotEditedNotLocation}
                    total={this.state.countAllNotEditedNotLocation}
                  />
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        ),
        value: 'notLocation'
      },
      {
        title: <div>فاکتور هایی که در مکان مورد نظر تحویل نشده</div>,
        content: (
          <>
            {this.state.listNotDelivered.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>راننده</td>
                      <td>تاریخ تحویل</td>
                      <td>تحویل </td>
                      <td>شناسه فاکتور</td>
                      <td>شماره فاکتور</td>
                      <td>تاریخ ثبت</td>
                      <td>نام خریدار</td>
                      <td>نام تحویل گیرنده</td>
                      <td>موبایل</td>
                      <td>موقعیت</td>
                    </tr>
                    {this.state.listNotDelivered.map((list, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberNotDelivered - 1) * this.state.sizeNotDelivered + index + 1}</td>
                        <td>
                          <span title={list.driver !== null ? list.driver.mobile : ''}>
                            {list.driver === null ? '-' : list.driver.name}
                          </span>
                        </td>
                        <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                        <td>{list.deliveredBetween ? 'بازه' : 'خارج از بازه'}</td>
                        <td>
                          <Link
                            to={{
                              pathname: '/baskets',
                              search: `?invoiceId=${list.invoice.invoiceId}`
                            }}
                            target={'_blank'}
                          >
                            {list.invoice.invoiceId}
                          </Link>
                        </td>
                        <td>{list.invoice.invoiceNum}</td>
                        <td>{jMoment(list.invoice.registerDate).format('jYY/jM/jD HH:mm')}</td>
                        <td>{list.invoice.buyerName}</td>
                        <td>{list.invoice.recipientName}</td>
                        <td>{list.invoice.mobile === null ? '-' : list.invoice.mobile.replace(/\+98/g, '0')}</td>
                        <td>
                          <button
                            onClick={() =>
                              this.openMapNotDelivered(
                                list.latitude,
                                list.longitude,
                                list.invoice.recipientName,
                                list.invoice.latitude,
                                list.invoice.longitude,
                                list.invoice.address
                              )
                            }
                          >
                            <img src={require('../../image/loc.svg')} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberNotDelivered}
                    pageSize={this.state.sizeNotDelivered}
                    currentPage={this.state.numberNotDelivered}
                    total={this.state.countAllNotDelivered}
                  />
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        ),
        value: 'notDelivered'
      },
      {
        title: <div>آدرس های ویرایش شده</div>,
        content: (
          <>
            {this.state.listEditedAddress.length > 0 ? (
              <>
                <table className="baseTable">
                  <tbody>
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>تاریخ تغییر</td>
                      <td>شناسه فاکتور</td>
                      <td>تحویل گیرنده</td>
                      <td>آدرس جدید</td>
                      <td>نام کاربری</td>
                      <td>کد مشتری</td>
                      <td>رساننده</td>
                      <td>کاربر تایید کننده</td>
                      <td>زمان تایید</td>
                      <td>موقعیت آدرس</td>
                      <td>تایید</td>
                      <td>تایید آدرس</td>
                    </tr>
                    {this.state.listEditedAddress.map((edited, index) => (
                      <tr key={index}>
                        <td>{(this.state.numberEditedAddress - 1) * this.state.sizeEditedAddress + index + 1}</td>
                        <td>{jMoment(edited.editionTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td>{edited.invoiceId}</td>
                        <td>{edited.recipientName}</td>
                        <td>{edited.address}</td>
                        <td>{edited.customer.username}</td>
                        <td>{edited.customer.userCode}</td>
                        <td>{edited.editor === null ? '-' : edited.editor.name}</td>
                        <td>{edited.operator === null ? '-' : edited.operator.name}</td>
                        <td>
                          {edited.confirmTime === null ? '-' : jMoment(edited.confirmTime).format('jYY/jMM/jDD HH:mm')}
                        </td>
                        <td>
                          <button
                            onClick={() =>
                              this.showLocationEditedAddress(
                                edited.latitude,
                                edited.longitude,
                                edited.recipientName,
                                edited.editedAddressId,
                                edited.confirmed
                              )
                            }
                          >
                            <img src={require('../../image/loc.svg')} alt={'loc'} />
                          </button>
                        </td>

                        <td className="confirmIgnor">
                          {edited.confirmed ? (
                            <img src={require('../../image/confirm.svg')} alt={'confirm'} title={'تایید شده'} />
                          ) : (
                            <img src={require('../../image/ignor.svg')} alt={'ignor'} title="تایید نشده" />
                          )}
                        </td>

                        <td>
                          {!edited.confirmed ? (
                            <button onClick={() => this.confirm(edited.editedAddressId, edited.recipientName)}>
                              <img src={require('../../image/editDriver.svg')} alt={'loc'} />
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-2">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumberEditedAddress}
                    pageSize={this.state.sizeEditedAddress}
                    currentPage={this.state.numberEditedAddress}
                    total={this.state.countAllEditedAddress}
                  />
                </div>
              </>
            ) : (
              <p className="text-danger text-center font-weight-bold my-2">هیچ نتیجه ای یافت نشد</p>
            )}
          </>
        ),
        value: 'editedAddress'
      },
      {
        title: <div>خط سیر رساننده</div>,
        content: (
          <>
            <div>
              {this.state.showFinalSearch === 'location' ? (
                <div className="d-flex">
                  {guide.map((item, index) => (
                    <div className="formComponent guide">
                      <p>{item.title}</p>
                      {item.url}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="d-flex">
                  {speedGuide.map((item, index) => (
                    <div className="formComponent guide">
                      <p>{item.title}</p>
                      {item.url}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {this.getMarkersHistory().map((item, index) => (
                  <Marker
                    position={item.location}
                    icon={divIcon({
                      html:
                        this.state.showFinalSearch === 'location'
                          ? this.changeColorMarker(item.state, this.convertDigit(jMoment(item.timestamp).format('HH')))
                          : this.changeColorMarkerBySpeed(
                              item.state,
                              this.convertDigit(jMoment(item.timestamp).format('HH'))
                            )
                    })}
                  >
                    <Popup>
                      <div className="text-center">سرعت :‌ {item.speed.toFixed(3) + ' کیلومتر بر ساعت '}</div>
                      <div className="text-center">
                        {item.timestamp && jMoment(item.timestamp).format('jYYYY/jMM/jDD HH:mm')}
                      </div>
                    </Popup>
                  </Marker>
                ))}
                <Polyline positions={this.getMarkersHistory()} pathOptions={limeOptions} />
              </Map>
              {/* <Map
                            google={this.props.google}
                            onClick={this.onMapClicked}
                            zoom={11}
                            style={style}
                            initialCenter={{
                                lat: 35.6892,
                                lng: 51.3890
                            }}
                        >
                            {this.state.history.map((item, index) => (
                                item.locations.map((marker, index) => (
                                    this.state.showFinalSearch === 'location' ?
                                        <Marker
                                            name={marker.timestamp}
                                            speed={marker.speed !== null ? ((marker.speed).toFixed(3)) : 0}
                                            scaledSize={new this.props.google.maps.Size(15,25)}
                                            icon={{url : this.changeColorMarker(item.state, this.convertDigit(jMoment(marker.timestamp).format('HH'))),scaledSize : new google.maps.Size(17, 25)}}
                                            key={`marker${index}`}
                                            onClick={this.onMarkerClick.bind(this)}
                                            position={{lat: marker.lat, lng: marker.lon}}
                                            // onClick={() => console.log((this.line))}
                                        />
                                        :
                                        <Marker
                                            name={marker.timestamp}
                                            speed={marker.speed !== null ? ((marker.speed).toFixed(3)) : 0}
                                            scaledSize={new this.props.google.maps.Size(15,25)}
                                            icon={{url : this.changeColorMarkerBySpeed(item.state, marker.speed),scaledSize : new google.maps.Size(17, 25)}}
                                            key={`marker${index}`}
                                            onClick={this.onMarkerClick.bind(this)}
                                            position={{lat: marker.lat, lng: marker.lon}}
                                            // onClick={() => console.log((this.line))}
                                        />


                                ))
                            ))}

                            <Polyline
                                path={final}
                                strokeColor="#000"
                                strokeOpacity={0.4}
                                strokeWeight={2}/>

                            <InfoWindow
                                marker={this.state.activeMarker}
                                visible={this.state.showingInfoWindow}>
                                <p className='mapinfoWindow'>{this.state.selectedPlace.name == null ? '-' : jMoment(this.state.selectedPlace.name).format('jYYYY/jMM/jDD HH:mm')}</p>
                                <p className='mapinfoWindow small font-weight-bold'>{'سرعت : '+this.state.selectedPlace.speed + ' کیلومتر بر ساعت '}</p>
                            </InfoWindow>

                        </Map> */}
            </div>
          </>
        ),
        value: 'trajectory'
      },
      {
        title: <div>آخرین مسیر رساننده</div>,
        content: (
          <>
            <div>
              {this.state.showFinalSearch === 'location' ? (
                <div className="d-flex">
                  {guide.map((item, index) => (
                    <div className="formComponent guide">
                      <p>{item.title}</p>
                      {item.url}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="d-flex">
                  {speedGuide.map((item, index) => (
                    <div className="formComponent guide">
                      <p>{item.title}</p>
                      {item.url}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {this.getMarkers().map((item, index) => (
                  <Marker
                    position={item.location}
                    icon={divIcon({
                      html: this.changeColorMarker(item.state, this.convertDigit(jMoment(item.timestamp).format('HH')))
                    })}
                  >
                    <Popup>
                      <div className="text-center">{this.state.driverName}</div>
                      <div className="text-center">سرعت :‌ {item.speed + ' کیلومتر بر ساعت '}</div>
                      <div className="text-center">
                        {item.timestamp && jMoment(item.timestamp).format('jYYYY/jMM/jDD HH:mm')}
                      </div>
                    </Popup>
                  </Marker>
                ))}
                <Polyline positions={this.getMarkers()} pathOptions={limeOptions} />
              </Map>
              {/* <Map
                            google={this.props.google}
                            zoom={11}
                            style={style}
                            initialCenter={{
                                lat: 35.6892,
                                lng: 51.3890
                            }}
                        >
                            {this.state.currentPosition.map((marker, index) => (
                                <Marker
                                    name={marker.timestamp}
                                    speed={marker.speed !== null ? ((marker.speed).toFixed(3)) : 0}
                                    icon={{url : this.changeColorMarker(marker.state, this.convertDigit(jMoment(marker.timestamp).format('HH'))),scaledSize : new google.maps.Size(17, 25)}}
                                    key={`marker${index}`}
                                    onClick={this.onMarkerClick.bind(this)}
                                    position={{lat: marker.lat, lng: marker.lon}}
                                />
                            ))}

                            <Polyline
                                path={currentPosition}
                                strokeColor="#000"
                                strokeOpacity={0.4}
                                strokeWeight={2}/>

                            <InfoWindow
                                marker={this.state.activeMarker}
                                visible={this.state.showingInfoWindow}>
                                <p className='mapinfoWindow'>{this.state.selectedPlace.name == null ? '-' : jMoment(this.state.selectedPlace.name).format('jYYYY/jMM/jDD HH:mm')}</p>
                                <p className='mapinfoWindow small font-weight-bold'>{'سرعت : '+this.state.selectedPlace.speed + ' کیلومتر بر ساعت '}</p>

                            </InfoWindow>

                        </Map> */}
            </div>
          </>
        ),
        value: 'currentLocation'
      },
      {
        title: 'گزارش تحویل شده‌ها',
        content: (
          <ReportDelivered
            value={this.state.deliveredItems}
            total={this.state.countDeliveredItems}
            currentPage={this.state.deliveredReportPageNumber}
            refreshReport={(data) =>
              this.refreshGetDelivered({
                ...data,
                driverId: this.state.driverId,
                planDateMin: this.state.fromDate,
                planDateMax: this.state.toDate
              })
            }
          />
        ),
        value: 'delivered'
      },
      {
        title: 'گزارش موقعیت‌ها',
        content: (
          <ReportLocation
            value={this.state.deliveredLocations}
            total={this.state.countDeliveredLocations}
            currentPage={this.state.deliveredLocationPageNumber}
            refreshReport={(data) =>
              this.refreshGetLocations({
                ...data,
                driverId: this.state.driverId,
                planDateMin: this.state.fromDate,
                planDateMax: this.state.toDate
              })
            }
          />
        ),
        value: 'locations'
      }
    ]

    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>رساننده ها</li>
            <li>کارنامه رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.changeFromDate}
                  onChangeToDate={this.changeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue
                  fromId="fromReg"
                  toId="toReg"
                  force
                />
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    force
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
                {this.state.activeTab === 3 && (
                  <div className="formComponent">
                    <label> نمایش نتایج بر اساس:</label>
                    <select className="form-control" onChange={this.showSearchBy} id="showSearch" name="showSearch">
                      <option value="location">موقعیت</option>
                      <option value="speed">سرعت</option>
                    </select>
                  </div>
                )}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
          </div>
          {this.state.filtered ? (
            <div className="card mt-2 p-1">
              <div className="card-header p-1">
                <ul className="p-0 m-0">
                  {stepData.map((item, index) => (
                    <li
                      onClick={() => this.changeTab(index, item)}
                      className={
                        index === this.state.activeTab
                          ? 'activeTab mx-1 d-inline-block p-2'
                          : 'deactiveTab d-inline-block mx-1 p-2'
                      }
                    >
                      {item.title}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="card-body p-1">{stepData[this.state.activeTab].content}</div>
            </div>
          ) : null}
        </div>
        <Modal
          isOpen={this.state.mapModalNotEditedNotLocation}
          toggle={() => this.setState({mapModalNotEditedNotLocation: false})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({mapModalNotEditedNotLocation: false})}>
            <p>موقعیت تحویل سفارش برای : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Marker
                  icon={divIcon({
                    html: orangeIcon,
                    iconSize: [30, 30],
                    iconAnchor: [10, 38]
                  })}
                  position={[this.state.latitude, this.state.longitude]}
                />
              </Map>
              {/* <Map
                                google={this.props.google}
                                zoom={15}
                                style={modalStyle}
                                initialCenter={{
                                    lat: this.state.latitude,
                                    lng: this.state.longitude
                                }}
                            >
                                <Marker
                                    icon={require('../../image/requestPack.png')}
                                    position={{lat: this.state.latitude, lng: this.state.longitude}}>
                                </Marker>
                            </Map> */}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({mapModalNotEditedNotLocation: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.mapModalNotDelivered}
          toggle={() => this.setState({mapModalNotDelivered: false})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({mapModalNotDelivered: false})}>
            <p>موقعیت تحویل سفارش برای : {this.state.recipientName}</p>
            <p>
              موقعیت ثبت شده در فاکتور : <img src={require('../../image/requestPack.png')} />
            </p>
            <p>آدرس ثبت شده در فاکتور : {this.state.address}</p>
            <p>
              موقعیت تحویل شده : <img src={require('../../image/finishPack.png')} />
            </p>
          </ModalHeader>
          <ModalBody>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Marker
                  icon={divIcon({
                    html: orangeIcon,
                    iconSize: [30, 30],
                    iconAnchor: [10, 38]
                  })}
                  title={this.state.recipientName}
                  position={[this.state.customerLatitude, this.state.customerLongitude]}
                />

                <Marker
                  icon={divIcon({
                    html: greenIcon,
                    iconSize: [30, 30],
                    iconAnchor: [10, 38]
                  })}
                  position={[this.state.latitude, this.state.longitude]}
                />
              </Map>
              {/* <Map
                                google={this.props.google}
                                zoom={11}
                                style={modalStyle}
                                initialCenter={{
                                    lat: this.state.latitude,
                                    lng: this.state.longitude
                                }}
                            >
                                <Marker
                                    icon={require('../../image/finishPack.png')}
                                    position={{lat: this.state.latitude, lng: this.state.longitude}}>
                                </Marker>
                                <Marker
                                    icon={require('../../image/reverseRequest.png')}
                                    position={{lat: this.state.customerLatitude, lng: this.state.customerLongitude}}>
                                </Marker>
                            </Map> */}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({mapModalNotDelivered: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.confirmModal}
          toggle={() => this.setState({confirmModal: false, check: false})}
          size="sm"
        >
          <ModalHeader toggle={() => this.setState({confirmModal: false, check: false})}>
            <p>تایید آدرس مشتری : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <p className="titleSm">
              <Checkbox name="check" tabIndex="4" onChange={this.changeFieldConfirm.bind(this)}>
                آیا از انجام عملیات مطمئن هستید؟
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              className="confirmBtnModal"
              disabled={!this.state.check || this.state.progressing ? true : false}
              onClick={this.confirmOk}
            >
              تایید
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({confirmModal: false, check: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.modalEditedAddress}
          toggle={() => this.setState({modalEditedAddress: false})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({modalEditedAddress: false})}>
            <p>آدرس مشتری : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Marker
                  icon={divIcon({
                    html: orangeIcon,
                    iconSize: [30, 30],
                    iconAnchor: [10, 38]
                  })}
                  title={this.state.recipientName}
                  position={[this.state.latitude, this.state.longitude]}
                />
              </Map>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modalEditedAddress: false})}>
              بستن
            </button>
            {!this.state.confirmedAddress ? (
              <button className="confirmBtnModal" onClick={() => this.confirm(this.state.id, this.state.recipientName)}>
                تایید آدرس
              </button>
            ) : null}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReportDriverCard
